<!-- <button  *ngIf="!isDeleteEnabled" (click)="enableCheckBox()" mat-button  aria-label="Action"><img style="height: 22px;" src="/assets/icon/noun-select.png"/></button>
<button  *ngIf="isDeleteEnabled"  (click)="getSelectedItems()" mat-button aria-label="Action"><img style="height: 22px;" src="/assets/icon/noun-delete.png"/></button> -->
<!-- <div>
  <mat-button-toggle value="Select" *ngIf="!isDeleteEnabled"
    style="height:30px;text-align:right;background-color: dimgray;color:whitesmoke; border-radius: 12px;"
    (change)="enableCheckBox()">Select</mat-button-toggle>

  <mat-button-toggle *ngIf="isDeleteEnabled" value="Select All"
    style="height:28px;text-align:right;background-color: dimgray;color:whitesmoke; border-radius: 12px;font-size: 11px;margin:3px;"
    (change)="selectAll()">Select All</mat-button-toggle>

  <button *ngIf="isDeleteEnabled" (click)="getSelectedItems()" mat-flat-button color="warn"
    aria-label="Action"
    style="height:28px;text-align:right;background-color: coral;color:whitesmoke; border-radius: 12px;font-size: 11px;margin:3px;padding:6px;">Delete</button>

  <button *ngIf="isDeleteEnabled" (click)="downloadItems()" mat-flat-button color="warn"
    aria-label="Action"
    style="height:28px;text-align:right;background-color: coral;color:whitesmoke; border-radius: 12px;font-size: 11px;margin:3px;padding:6px;">Download</button>
  <button *ngIf="isDeleteEnabled" (click)="cancelSelection()" mat-flat-button color="primary"
    aria-label="Action"
    style="height:28px;text-align:right;background-color: gainsboro;color:black; border-radius: 12px;font-size: 11px;margin:3px;padding:6px;">Cancel</button>
</div> -->
<mat-grid-list
  [cols]="col"
  [rowHeight]="rowHeight"
  [gutterSize]="gutterSize + 'px'"
>
  <!-- <lightgallery id="lightgallery" [settings]="settings" [onBeforeSlide]="onBeforeSlide" [onInit]="onInit" [onAfterSlide]="onAfterSlide" [onAfterClose]="onAfterClose" [onAfterAppendSlide]="onAfterAppendSlide">
    <ng-container *ngFor="let imageItem of images">
      <a
        *ngIf="imageItem?.mime_type != 'video'"
        [attr.href]="imageItem.fileUrl"
        data-src="imageItem.fileUrl"
        [attr.data-download-url]="imageItem.downloadUrl"
      >
        <mat-grid-tile [rowspan]="item.rows">
          <app-grid-gallery-item
            #item
            [image]="imageItem"
            [rowHeight]="rowHeight"
            [gutterSize]="gutterSize"
          >
          </app-grid-gallery-item>
        </mat-grid-tile>
      </a>
      <a
        *ngIf="imageItem?.mime_type === 'video'"
        [attr.data-video]="imageItem.dataVideo"
        [attr.data-download-url]="imageItem.downloadUrl"
      >
        <mat-grid-tile [rowspan]="item.rows">
          <app-grid-gallery-item
            #item
            [image]="imageItem"
            [rowHeight]="rowHeight"
            [gutterSize]="gutterSize"
          >
          </app-grid-gallery-item>
        </mat-grid-tile>
      </a>
    </ng-container>
  </lightgallery> -->
  <lightgallery id="lightgallery" [settings]="settings"  [onInit]="onInit" [onAfterSlide]="onAfterSlide" [onAfterClose]="onAfterClose" [onAfterAppendSlide]="onAfterAppendSlide">
    <ng-container *ngFor="let imageItem of images">
      <a
        [attr.href]="imageItem?.mime_type != 'video' ? imageItem.fileUrl : null"
        [attr.data-src]="imageItem?.mime_type != 'video' ? imageItem.fileUrl : null"
        [attr.data-video]="imageItem?.mime_type === 'video' ? imageItem.dataVideo : null"
        [attr.data-download-url]="imageItem.fileUrl">
     
        <mat-grid-tile [rowspan]="item.rows">
      
          <app-grid-gallery-item
            #item
            [image]="imageItem"
            [rowHeight]="rowHeight"
            [gutterSize]="gutterSize"
            [totalImages]="totalImages"
            [imageIndex] = "images.indexOf(imageItem) + 1" 
            [isAnnonymous]="isAnnonymous"
            [isDeleteEnabled]="isDeleteEnabled"
          >       
          </app-grid-gallery-item> 
        </mat-grid-tile>
      </a>
    </ng-container>
   
  </lightgallery>
</mat-grid-list>
